export interface EmployeeLocation {
  $id: string;
  LocationId: number;
  MerchantId: number;
}
